import Layout from "components/Layout";
import { useLocation } from "react-router-dom";

const SettingsPage = () => {
  const pathname = useLocation().pathname;

  return (
    <Layout
      title="서비스 관리"
      nav={[
        {
          label: "조교관리",
          links: [
            {
              label: "계정관리",
              path: "/settings",
              isActive: pathname == "/settings",
            },
            {
              label: "등급관리",
              path: "/settings/grade",
              isActive: pathname.includes("/settings/grade"),
            },
            {
              label: "급여관리",
              path: "/settings/payment",
              isActive: pathname.includes("/settings/payment"),
            },
          ],
        },
        {
          label: "운영관리",
          links: [
            {
              label: "공지사항",
              path: "/settings/notice",
              isActive: pathname.includes("/settings/notice"),
            },
            {
              label: "FAQ",
              path: "/settings/faq",
              isActive: pathname.includes("/settings/faq"),
            },
          ],
        },
      ]}
    />
  );
};

export default SettingsPage;
